import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { Button, Image, FormControl } from 'react-bootstrap';
import './Promo.scss';
import { useStateValue } from '../../../utilities/StateProvider';
import { api } from '../../../utilities/fetch';

export default function Promo(props) {

    const [{ cart, isInterior }, dispatch] = useStateValue();
    const [quantity, setQuantity] = useState(0);
    const [image, setImage] = useState(null);

    const hasCooler = Number(props.data.meta.cooler);

    useEffect(() => {
        const getData = async (mediaId) => {
            const imgDetails = await api.get(`media/${mediaId}`);
            setImage(imgDetails.data.source_url);
            !!cart[props.data.slug] && setQuantity(cart[props.data.slug].quantity);
        }
        getData(props.data.featured_media);
    }, []);

    const toggleModal = () => {
        props.setModal(true);
    }

    const handleChangeQuantity = (e) => {
        const newQuantity = e.currentTarget.value;
        setQuantity((!!props.data.meta.max && Number(newQuantity) > Number(props.data.meta.max)) ? props.data.meta.max : newQuantity);
    }

    const addToCart = () => {
        const newCart = {
            ...cart,
            [props.data.slug]: {
                price: props.data.meta.price,
                priceInterior: props.data.meta.price_interior,
                name: props.data.title.rendered,
                content: props.data.content.rendered,
                type: 'pandaparty',
                quantity: quantity,
            }
        }
        
        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    return (
        <div className="promo-container">
            <Image src={image} height={150} />
            <div className="promo-title">{props.data.title.rendered}</div>
            <div className="promo-description">
                {parse(props.data.content.rendered)}
            </div>
            {!!hasCooler && <div><Button className="shop-button" onClick={toggleModal}>Personalizar<br/>cooler</Button></div>}
            <FormControl
                className="quantity"
                name="quantity"
                size="sm"
                placeholder="Cantidad"
                pattern="[1-9]\d*"
                value={quantity}
                title="Solo puede agregar numeros mayores a 0"
                onChange={handleChangeQuantity}
            />
            <div className="price">{`$${!isInterior ? props.data.meta.price : props.data.meta.price_interior}`}</div>
            <div><Button className="shop-button" onClick={addToCart}>Agregar<br/>al carrito</Button></div>
        </div>
    )
}
